import React from 'react'
import { Col, Row } from 'react-bootstrap';

const Unauthorized = () => {
    return (
        <div className="tnc-decline">
            <Row className="center">
                <Col>
                    <div className="tnc-decline tnc-decline-message">
                        <br />
                        <br />
                        <span className="not-authorized">You are not authorized to access this page.</span>
                        <span className="not-authorized">Kindly contact Admin.</span>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default Unauthorized;